import { render } from "./EnglishClassesForSecondary.vue?vue&type=template&id=9fb54974&scoped=true"
import script from "./EnglishClassesForSecondary.vue?vue&type=script&lang=js"
export * from "./EnglishClassesForSecondary.vue?vue&type=script&lang=js"

import "./EnglishClassesForSecondary.vue?vue&type=style&index=0&id=9fb54974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb54974"]])

export default __exports__